import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import 'firebase/storage'

const firebaseConfig = { 

  apiKey: "AIzaSyDMLjEwvqg8ocYUWXDnNkNZptFgYlKCgp0",
    authDomain: "itranslatectx.firebaseapp.com",
    databaseURL: "https://itranslatectx-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "itranslatectx",
    storageBucket: "itranslatectx.appspot.com",
    messagingSenderId: "1015850947245",
    appId: "1:1015850947245:web:a1aeb2afe173dc5b7bec24",
    measurementId: "G-C1ZPKYP9PF"
};

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}



export const storage = firebase.storage()
export const database = firebase.database();
export default firebase;
